export const deleteRolePermission = (payload: { role_id: number, permission_id: number }) => ({
    type: "@saga/DELETE_ROLE_PERMISSION",
    payload
});